import { useTranslation } from 'react-i18next'
import { authenticatedNavigation, type AppModuleRoute } from './navigation'

export interface TranslatedRoute extends Omit<AppModuleRoute, 'labelKey' | 'titleKey' | 'eyebrowKey' | 'descriptionKey'> {
  label: string
  title: string
  eyebrow: string
  description: string
}

export function useNavigation(): TranslatedRoute[] {
  const { t } = useTranslation()

  return authenticatedNavigation.map((route) => ({
    path: route.path,
    icon: route.icon,
    permissions: route.permissions,
    hidden: route.hidden,
    label: t(route.labelKey),
    title: t(route.titleKey),
    eyebrow: t(route.eyebrowKey),
    description: t(route.descriptionKey),
  }))
}

export function useActiveRoute(pathname: string): TranslatedRoute | undefined {
  const navigation = useNavigation()
  // Sort by path length descending so more specific (longer) routes match first.
  // This prevents /admin from shadowing /changelog.
  const sorted = [...navigation].sort((a, b) => b.path.length - a.path.length)
  return (
    sorted.find(
      (route) =>
        pathname === route.path || pathname.startsWith(`${route.path}/`),
    ) ?? navigation[0]
  )
}
